export default "__VITE_ASSET__c34b5b93__"